import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { otpValidation } from 'src/app/models/otpValidation.model';
import { AdobeAnalyticsService } from 'src/app/services/adobe-analytics.service';
import { ProductService } from 'src/app/services/product.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';


@Component({
  selector: 'app-otp-verification',
  templateUrl: './otp-verification.component.html',
  styleUrls: ['./otp-verification.component.scss']
})
export class OtpVerificationComponent implements OnInit {
  @ViewChild('ngOtpInput', { static: false }) ngOtpInput: any;
  @Input('data') data: any;
  otp: string = '';
  otpVerificationScreen: boolean = false;
  otpValidationModel: otpValidation = new otpValidation();
  mobileNumber: any = '';
  notificationValue: any = '';
  maskedAccountNo: string = '';
  token: string;
  config = {
    allowNumbersOnly: true,
    length: 6,
    // isPasswordInput: true,
    disableAutoFocus: true,
    placeholder: '●',
    inputStyles: {
      width: '36px',
      height: '36px',
    },
  };
  showSubscriptionTemplate: boolean = false;
  showSuccessTemplate: boolean = false;
  sku: any;
  hiddenHeader: boolean;
  categoryName: string;
  isArabic: boolean;
  showOTPError = true;
  OTPErrorMSG: any;
  enableResendcode: boolean = false;
  mobileErrorMSG: any;
  showErrorTemplate: boolean;
  ismobileScreen: boolean;
  language: string;
  showArenaProTemplate: boolean = false;
  minutes:any;
  seconds:any;
  totalInSeconds:any;
  constructor(
    private modalController: ModalController,
    private productService: ProductService,
    private UTS: UtilitiesService,
    private AAS: AdobeAnalyticsService,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService,
  ) {

  }


  ngOnInit() {
    const w = document.documentElement.clientWidth || window.innerWidth;
    if (w < 992) {
      this.ismobileScreen = true;
    } else {
      this.ismobileScreen = false;
    }
    const locale = this.UTS.getLocaleLanguage().toLocaleLowerCase();
    this.language = localStorage.getItem('language') && localStorage.getItem('language').toLocaleLowerCase();
    if (locale == 'ar') {
      this.isArabic = true;
    } else {
      this.isArabic = false;
    }

    /**
* ETWS-689 ETWS-689 || Authorization OTP for Key Transactions start
*/
    if (this.data && this.data?.onlyOTPScreenEnable) {
      this.mobileNumber = this.data?.mobileNumber;
      this.notificationValue = this.data?.notificationValue;
      this.sku = this.data?.sku;
      this.getOTP();
    }
    /**
    * ETWS-689 ETWS-689 || Authorization OTP for Key Transactions end
    */
  }


  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController
      .dismiss({
        dismissed: true,
      })
      .then(() => {
        this.showSubscriptionTemplate = false;
        this.showSuccessTemplate = false;
        this.hiddenHeader = false;
        this.UTS.clearError();
        this.cdr.detectChanges();
      });
  }

  getOTP() {
    this.mobileErrorMSG = '';
    this.UTS.clearError();
    this.productService.generateOTPLogedInUser(this.mobileNumber,this.notificationValue).subscribe(
      (resp) => {
        if (resp?.maskedAccountNo) {
          this.maskedAccountNo = resp?.maskedAccountNo;
        }
        else {
          this.maskedAccountNo = this.notificationValue;
        }
        this.token = resp?.token;
        this.otpVerificationScreen = true;
          this.resendCodeTimer();
      },
      (e) => {
        // this.UTS.error(e.error.message);
        this.mobileErrorMSG = e?.error?.message;
        if (e.error.message == "NO_ACCOUNT_EMAIL_FOR_ELIFE_NUMBER") {
          let errorTitle = 'Invalid number';
          let errorMessage =
            'Sorry, this number isn’t registered with etisalat. Please try again with another number.';
          if (this.isArabic) {
            errorTitle = 'الرقم غير صحيح';
            errorMessage =
              'عذرًا، هذا الرقم غير مُسجل لدى إتصالات. يرجى إعادة المحاولة باستخدام رقم آخر';
          }
          this.mobileErrorMSG = `${errorTitle}: ${errorMessage}`;
          this.AAS.pageErrorEvent(this.data.type, "eligibility", "error - Not eligible", "400", false);
        }
      }
    );
  }

  resendOTP() {
    if (this.enableResendcode == false) {
      return false;
    }
    this.mobileErrorMSG = '';
    this.ngOtpInput.setValue(null);
    this.showOTPError = false;
    this.UTS.clearError();
    //&& resp.accountId remove account ID for non logged in customer
    this.productService.generateOTPLogedInUser(this.mobileNumber,this.notificationValue).subscribe(
      (resp) => {
        if (resp?.maskedAccountNo) {
          this.maskedAccountNo = resp?.maskedAccountNo;
        }
        else {
          this.maskedAccountNo = this.notificationValue;
        }
        this.token = resp?.token;
        this.otpVerificationScreen = true;
          this.resendCodeTimer();
      },
      (e) => {
        this.mobileErrorMSG = e.error.message;
      }
    );
  }

  changeOTP(otp: string) {
    this.showOTPError = false;
    this.otp = otp;
  }

  validateOtp() {
    this.showOTPError = false;
    this.UTS.clearError();
    this.otpValidationModel.accountNo = this.mobileNumber;
    this.otpValidationModel.authValue = this.otp;
    this.otpValidationModel.authType = 'otp';
    this.otpValidationModel.token = this.token;
    this.productService.validateOTP(this.otpValidationModel).subscribe(
      (resp) => {
        this.showOTPError = false;
        if (resp.success) {
          //check here 
          this.modalController.dismiss({
            validated: true,
          });

        } else {
          this.translate.get('OTP_INVALID').subscribe((message) => {
            this.showOTPError = true;
            this.OTPErrorMSG = message;
          });
        }
      },
      (e) => {
        this.UTS.error(e?.error?.message);
      }
    );
  }
  resendCodeTimer() {
    // Set the date we're counting down to
    const d = new Date();
    //'Nov 18, 2021 11:29:00'
    const timer =
      d.getFullYear() +
      '-' +
      Number(Number(d.getUTCMonth()) +
        1) +
      '-' +
      d.getDate() +
      ' ' +
      d.getHours() +
      ':' +
      (d.getMinutes() + 2) +
      ':' +
      d.getSeconds();
    let countDownDate = new Date(timer.replace(/-/g, "/")).getTime();
    // Update the count down every 1 second

    this.enableResendcode = false;
    let x = setInterval(() => {
      // Get today's date and time
      let now = new Date().getTime();

      // Find the distance between now and the count down date
      let distance = countDownDate - now;
      if (distance <= 0) {
        clearInterval(x);
        this.enableResendcode = true;
        this.minutes = 0;
        this.seconds = 0;
        this.totalInSeconds = 0;
        return;
      }
      // Time calculations for days, hours, minutes and seconds
      let days: any = Math.floor(distance / (1000 * 60 * 60 * 24));
      days = days < 10 ? '0' + days : days;
      let hours: any = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      hours = hours < 10 ? '0' + hours : hours;
      this.minutes = Math.floor(
        (distance % (1000 * 60 * 60)) / (1000 * 60)
      );
      this.minutes = this.minutes < 10 ? '0' + Number(this.minutes) : Number(this.minutes);

      this.seconds = Math.floor((distance % (1000 * 60)) / 1000);
      this.seconds = this.seconds < 10 ? '0' + Number(this.seconds) : Number(this.seconds);
      this.totalInSeconds = Number(this.minutes * 60) + Number(this.seconds) + '';
    }, 1000);
  }

}
